import { TransformDate } from '../../../decorators/transform-date.decorator';
import { TransformInt } from '../../../decorators/transform-int.decorator';
import { CountryDto } from '../../settings/dtos/country.dto';

export class BaseDriverDrivingLicenseDto {
  @TransformInt()
  id?: number;

  number?: string | null;

  category?: string | null;

  @TransformDate()
  issueDate?: Date | null;

  @TransformDate()
  expiryDate?: Date | null;

  @TransformInt()
  issuedByCountryId?: number | null;

  issuedByCountry?: CountryDto | null;
}
